import { find } from 'lodash-es';
import SecurityGroup from '@/common/models/securityGroup.model';
import { SECURITY_GROUP_DEFAULT_NAME } from '@/common/constants/networks.constants';
import useAuthStore from '@/common/store/pinia/auth';

const securityGroupsGetters: CommonGetterTree<any> = {
  defaultSecurityGroup: (state, getters) => projectId => {
    const authStore = useAuthStore();
    return find(
      // eslint-disable-next-line no-underscore-dangle
      Object.keys(state.itemsMap).map(getters._mapItem),
      {
        projectId: projectId || authStore.currentProject,
        name: SECURITY_GROUP_DEFAULT_NAME
      });
  }
};

const securityGroupsActions: CommonActionTree<any> = {
  REMOVE_SECURITY_GROUP_RULE({ dispatch }, { securityGroupId, ruleId }): Promise<FetchResponse> {
    return this.$api.delete(`/api/v2/compute/security-group-rules/${ruleId}/`)
      .then(() => dispatch('FETCH_ITEM', { id: securityGroupId }));
  },
  CREATE_SECURITY_GROUP_RULE({ dispatch }, { securityGroupId, body }): Promise<FetchResponse> {
    return this.$api.post('/api/v2/compute/security-group-rules', body)
      .then(() => dispatch('FETCH_ITEM', { id: securityGroupId }));
  }
};

export default new class implements CommonStore<any, SecurityGroup> {
  name = 'securityGroups';
  resource = '/api/v2/compute/security-groups';
  Model = SecurityGroup;
  pagingSupport = true;
  getters = securityGroupsGetters;
  actions = securityGroupsActions;
}();
